import { searchConnector } from './connector';

export interface SearchResultResponse {
	numberOfResults: number;
	query: string;
	searchResults: Search.SearchResult[];
}

export const getSearchResults = async (searchUrl: string, query: string, accessToken: string): Promise<SearchResultResponse> => {
	return await searchConnector({ searchUrl, query, accessToken });
};
